import { useEffect, useState } from 'react';
import { useTheme } from 'context/ThemeContext';
import { buildCategorySelectStyles, buildSelectStyles } from '../helpers/selectStyles';
import { formatStatusOption, formatTypeOption } from '../helpers/formatFilterOption';
import type { TaskFilterModel } from '../model/useTaskFilter';
import TaskFilterMultiSelect from './TaskFilterMultiSelect';
import TaskFilterRelated from './TaskFilterRelated';
import TaskFilterUsers from './TaskFilterUsers';

interface TaskFilterFormProps {
    filter: TaskFilterModel;
    showExecutorFilter: boolean;
    showControllerFilter: boolean;
}

const TaskFilterForm = ({
    filter,
    showExecutorFilter,
    showControllerFilter,
}: TaskFilterFormProps) => {
    const { darkTheme } = useTheme();
    const [selectTheme, setSelectTheme] = useState(() => buildSelectStyles(Boolean(darkTheme)));
    const [categorySelectTheme, setCategorySelectTheme] = useState(() =>
        buildCategorySelectStyles(Boolean(darkTheme)),
    );
    const {
        t,
        canFilterRelated,
        typeOptions,
        categoryOptions,
        statusOptions,
        selectedTypes,
        selectedCategories,
        selectedStatuses,
        handleChangeTypes,
        handleChangeCategories,
        handleChangeStatuses,
    } = filter;

    useEffect(() => {
        setSelectTheme(buildSelectStyles(Boolean(darkTheme)));
        setCategorySelectTheme(buildCategorySelectStyles(Boolean(darkTheme)));
    }, [darkTheme]);

    const showPeople = showExecutorFilter || showControllerFilter || canFilterRelated;

    return (
        <div className="off-filter-content px-3">
            <TaskFilterMultiSelect
                label={t('filterType')}
                options={typeOptions}
                value={selectedTypes}
                onChange={handleChangeTypes}
                styles={selectTheme}
                formatOptionLabel={formatTypeOption}
                className="w-100 task-filter-select"
                classNamePrefix="task-filter-select"
            />
            <TaskFilterMultiSelect
                label={t('filterCategory')}
                options={categoryOptions}
                value={selectedCategories}
                onChange={handleChangeCategories}
                styles={categorySelectTheme}
            />
            <TaskFilterMultiSelect
                label={t('filterStatus')}
                options={statusOptions}
                value={selectedStatuses}
                onChange={handleChangeStatuses}
                styles={selectTheme}
                formatOptionLabel={formatStatusOption}
                isSearchable={false}
                className="w-100 task-filter-select"
                classNamePrefix="task-filter-select"
            />
            {showPeople ? (
                <div className="mb-3">
                    <TaskFilterUsers
                        filter={filter}
                        showExecutorFilter={showExecutorFilter}
                        showControllerFilter={showControllerFilter}
                    />
                    <TaskFilterRelated filter={filter} />
                </div>
            ) : null}
        </div>
    );
};

export default TaskFilterForm;
